// React and rendering setup
import "./instrument";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

// Main App component
import App from "./App.tsx";

// Global styles and localization
import "./index.css";
import "./locales/li8n.js";
import "leaflet/dist/leaflet.css";

// Redux store setup
import { Provider } from "react-redux";
import store from "./store/indexRedux.ts";

// Polyfills for Node.js compatibility
import { Buffer } from "buffer";
import process from "process";
window.global = window;
window.Buffer = Buffer;
window.process = process;

document.addEventListener("wheel", () => {
  const el = document.activeElement;
  if (el instanceof HTMLInputElement && el.type === "number") {
    el.blur();
  }
}, { passive: true });

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </StrictMode>
);
